import { ChevronDown } from "lucide-react";

const faqItems = [
  { question: "Who can purchase from Kratown?", answer: "You must be at least 21 years old to enter this site and to purchase Kratown products." },
  { question: "Can Kratown ship to my address?", answer: "Shipping availability depends on your destination and current regulations. Review our Shipping Restrictions policy before ordering." },
  { question: "How does Kratown approach lab testing?", answer: "Kratown quality standards include third-party lab testing. Contact Kratown if you need help locating available product information before ordering." },
  { question: "How do I know whether a product is available?", answer: "Current availability, package options, and pricing appear on the product page. Select a package option before adding an available item to your cart." },
  { question: "When will I see shipping and tax totals?", answer: "Enter and save your shipping address at checkout to view available shipping methods and the current order total." },
  { question: "Where do I enter payment details?", answer: "Payment details are entered through the secure hosted payment form after you confirm your order details and eligibility." },
];

export function FAQSection() {
  return (
    <section id="faq" aria-labelledby="faq-heading" className="container pb-16">
      <div className="grid gap-8 lg:grid-cols-[0.72fr_1.28fr] lg:items-start">
        <div>
          <p className="section-kicker">Questions, answered</p>
          <h2 id="faq-heading" className="mt-4 max-w-[10ch] font-serif text-5xl text-white md:text-6xl">The details that matter before you order.</h2>
          <p className="mt-5 max-w-md text-base leading-8 text-white/70">For shipping eligibility, policy details, or help with an order, we keep the next steps clear.</p>
        </div>
        <div className="space-y-3">
          {faqItems.map((item) => (
            <details key={item.question} className="edge-panel group rounded-[1.5rem] px-5 py-1">
              <summary className="flex list-none items-center justify-between gap-5 py-5 text-left text-lg font-semibold text-white marker:content-none">
                {item.question}
                <ChevronDown className="h-5 w-5 shrink-0 text-[#8beeff] transition-transform group-open:rotate-180" aria-hidden="true" />
              </summary>
              <p className="border-t border-white/8 pb-5 pt-4 text-base leading-8 text-white/72">{item.answer}</p>
            </details>
          ))}
          <div className="flex flex-wrap gap-x-6 gap-y-3 pt-2">
            <a href="/shipping-restrictions" className="inline-flex text-sm uppercase tracking-[0.16em] text-[#d9ff8a] underline-offset-4 hover:underline">Read shipping restrictions</a>
            <a href="/contact" className="inline-flex text-sm uppercase tracking-[0.16em] text-[#8beeff] underline-offset-4 hover:underline">Contact Kratown</a>
          </div>
        </div>
      </div>
    </section>
  );
}
